import React, { createContext, useContext, useMemo, useReducer } from 'react'
import { TAppProps, TAppState, TAppContext } from './types'
import { jobDetailReducer } from './reducer'
import { ELanguage } from '@microfrontends/react-components'
import { EPages } from '@/common/types/page'
import { TUser } from '@/common/types/user'


export const initialStore: Required<TAppState> = {
    user: null,
    pageName: EPages.HOMEPAGE
}

const Context = createContext<TAppContext>({
    state: initialStore,
    props: {
        langCode: ELanguage.VI
    },
    dispatch: () => { }
})

export type TStaticPageProviderProps = TAppProps & {
    children: React.ReactNode
    user: Partial<TUser> | null
}

export const useAppStore = () => useContext(Context)

const StaticPageProvider = (props: TStaticPageProviderProps) => {

    const [state, dispatch] = useReducer(jobDetailReducer, {
        ...initialStore,
        user: props.user
    })

    const contextValue = useMemo(() => {
        return {
            state,
            props,
            dispatch
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state])

    return (
        <Context.Provider value={contextValue}>{props.children}</Context.Provider>
    )
}

export default StaticPageProvider
